/** Suppress WebKit's selection/loupe gestures only on the live flight surface.
 * A non-passive touchstart is needed alongside CSS on iOS; pointer capture
 * still owns both thumbs. Real buttons, menus and paused settings keep their
 * native activation and scrolling. All listeners share the player lifetime. */
export function installSkyTouchGuard({ surface, listen, active }) {
  const exempt = (target) => target?.closest?.('.sky-overlay, .sky-control-settings');
  for (const name of ['selectstart', 'contextmenu', 'dragstart'])
    listen(surface, name, (event) => {
      if (active() && !exempt(event.target)) event.preventDefault();
    });
  listen(
    surface,
    'touchstart',
    (event) => {
      if (!active() || exempt(event.target)) return;
      const flight =
        event.target === surface ||
        event.target?.closest?.('.sky-canvas, .sky-steering-pad, .sky-aim-pad');
      if (flight && event.cancelable) event.preventDefault();
    },
    { passive: false },
  );
}
